import { formManager } from './activateAccount.hoc';
import { controllerDefinitionBuilder } from '@app/components/Form/helpers';
import { StringRulesBuilder } from '@utilities/json-driven-validator/pre-built-contrains';

export default controllerDefinitionBuilder()
  .addControllerConfig({
    label: '',
    type: 'password',
    name: 'password',
    autoComplete: 'off',
    responsive: { xs: 12 },
    defaultValue: undefined,
    defaultViewMode: 'edit',
    autoGeneratePassword: true,
    placeholder: 'Password1FieldPlaceholder',
    onAutoGenerationPasswordFired: (value: string) => formManager.setControllerState('confirmPassword', value),
    validationRules: StringRulesBuilder.new().required('Password1FieldIsRequired').get(),
  })
  .addControllerConfig({
    label: '',
    type: 'password',
    autoComplete: 'off',
    responsive: { xs: 12 },
    defaultViewMode: 'edit',
    defaultValue: undefined,
    name: 'confirmPassword',
    placeholder: 'Password2FieldPlaceholder',
    validationRules: StringRulesBuilder.new().required('Password1FieldIsRequired').get(),
  })
  .addControllerConfig({
    label: '',
    placeholder: '',
    type: 'recaptcha',
    name: 'captchaToken',
    responsive: { xs: 12 },
    defaultViewMode: 'edit',
    defaultValue: undefined,
    validationRules: StringRulesBuilder.new().required('RecaptchaFieldIsRequired').get(),
  })
  .get();
